<template />

<script>
export default {
    props: {
        purchase_price: {},
        net_sale_price: {},
        our_sale: {},
        our_purchase: {},
        fees_paid_gross: {},
        total_earnest_money: {},
        total_earnest_entered: {},
        total_earnest_percent: {},
        scheduled_closing_date: {},
        contract_acceptance_date: {},
        list_date: {},
        office_name: {},
        office_number: {},
        attorney_review_date: {},
        list_side_total_net_to_agent: {},
        purchase_side_total_net_to_agent: {},
        feasibility_date: {},
        feasibility_additional_money_amount: {},
        feasibility_additional_money_is_due: {},
        entitlement_date: {},
        property_progress_sections: {},
        property_progress_overall: {},
        square_feet: {},
        commercial_tenants: {},
        zoning_change_is_required: {},
        zoning_change_required_date: {},
        currency: {},
        currency_symbol: {},
        tenant: {},
    },

    created() {
        store.state = Object.assign({}, this.$props);
    },
}
</script>
